var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCactus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C7 2.89543 7.89543 2 9 2C10.1046 2 11 2.89543 11 4V10H12C12.5523 10 13 9.55228 13 9V7.5C13 6.67157 13.6716 6 14.5 6C15.3284 6 16 6.67157 16 7.5V9C16 11.2091 14.2091 13 12 13H11V17H10.9922C11.0661 17.0343 11.1396 17.0698 11.2127 17.1063L13.1559 18.078C14.6717 18.8358 16.3435 19.1695 18 19.0717V15.75H17C16.0335 15.75 15.25 14.9665 15.25 14V13C15.25 12.5858 15.5858 12.25 16 12.25C16.4142 12.25 16.75 12.5858 16.75 13V14C16.75 14.1381 16.8619 14.25 17 14.25H18V12C18 11.4477 18.4477 11 19 11C19.5523 11 20 11.4477 20 12V15.25H21C21.1381 15.25 21.25 15.1381 21.25 15V14C21.25 13.5858 21.5858 13.25 22 13.25C22.4142 13.25 22.75 13.5858 22.75 14V15C22.75 15.9665 21.9665 16.75 21 16.75H20V18.7386C20.3343 18.6456 20.6649 18.534 20.9904 18.4038C21.474 18.2104 22 18.5665 22 19.0874V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V19.121C2 18.4256 2.36491 17.7811 2.96129 17.4232C4.20532 16.6768 5.59532 16.2703 7 16.2088V11H6C3.79086 11 2 9.20914 2 7V5.5C2 4.67157 2.67157 4 3.5 4C4.32843 4 5 4.67157 5 5.5V7C5 7.55228 5.44772 8 6 8H7V4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactus3);
export default __webpack_public_path__ + "static/media/cactus-3.e0b7554e412b8af9b05b6c616be7669f.svg";
export { ForwardRef as ReactComponent };